// Shared hero video asset — used by both the Landing page and About page
// so they reference the identical Cloudflare Stream source, not a duplicate copy.
export const LANDING_HERO_VIDEO_URL =
  'https://customer-q87c1i5e2o40bvjt.cloudflarestream.com/c9419e44d69b7ceb47e403986719c107/downloads/default.mp4';
